export default {"src":"/_next/static/media/twoPeopleTalkLegal_64.070be5f6.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};